import React from 'react';
import {useTranslation} from 'react-i18next';
import {StyledNetSuiteJournalEntriesPage} from './StyledNetSuiteJournalEntriesPage';
import DashboardPageTransition from '../../components/animations/DashboardPageTransition';
import BalancePageHeader from '../../components/pages/TransactionsPage/BalancePageHeader/BalancePageHeader';
import PageDocumentDetails from '../../components/PageDocumentDetails/PageDocumentDetails';
import JournalEntriesTabs from '../../components/pages/NetSuiteJournalEntriesPage/JournalEntriesTabs';

const NetSuiteJournalEntriesPage = () => {
  const [t] = useTranslation('main');

  const title = t('pageTitles.journalEntries');

  return (
    <StyledNetSuiteJournalEntriesPage>
      <PageDocumentDetails title={title} />
      <BalancePageHeader breadcrumbs={[{ title }]} />
      <DashboardPageTransition>
        <JournalEntriesTabs />
      </DashboardPageTransition>
    </StyledNetSuiteJournalEntriesPage>
  );
}

export default NetSuiteJournalEntriesPage;
